import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_music",
  "use": "icon-icon_music-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-icon_music\"><g fill=\"none\" fill-rule=\"evenodd\"><circle stroke=\"#FFF\" stroke-width=\"3\" cx=\"22\" cy=\"22\" r=\"20.5\" /><path d=\"m31.744 11-7.738 1.3c-1.35.4-2.434 1.85-2.434 3.25v9.832s-.818-.567-2.602-.3c-2.634.384-4.767 2.486-4.767 4.687 0 2.2 2.133 3.55 4.767 3.166 2.634-.382 4.57-2.417 4.57-4.62v-8.061c0-.968 1.115-1.384 1.115-1.384 4.736-.685 7.099-3.308 7.089-7.87Z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol